module.exports = __webpack_public_path__ + "static/media/ruins_background.41cd15cb.jpg";